import { createSlice } from '@reduxjs/toolkit';

import { closeTransferWindowDrawer, openTransferWindowDrawer } from './actions';
import { TransferWindowDrawerState } from './types';

export const initialState: TransferWindowDrawerState = {
  isDrawerOpen: false,
};

export const transferWindowDrawerSlice = createSlice({
  name: 'transferWindowDrawer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(closeTransferWindowDrawer, (state) => {
      state.isDrawerOpen = false;
    });
    builder.addCase(openTransferWindowDrawer, (state) => {
      state.isDrawerOpen = true;
    });
  },
});
